import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class CourseService {

  public endpoint: string;

  constructor(
    public httpClient: HttpClient
  ) {
    this.endpoint = '/api/v2/client/course';
  }

  fetchAll(): Observable<any> {
    return this.httpClient.get(`${this.host}/api/v2/client/course/user/${this.user}`, this.options);
  }

  find(id: number): any {
    return this.httpClient.get(`${this.host}${this.endpoint}/${id}`, this.options);
  }

  create(data: any): Observable<any> {
    return this.httpClient.post(`${this.host}${this.endpoint}`, data, this.options);
  }

  update(id: number, data: any) {
    return this.httpClient.put(`${this.host}${this.endpoint}/${id}`, data, this.options);
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(`${this.host}${this.endpoint}/${id}`, this.options);
  }

  get host(): string {
    let host = localStorage.getItem('apiURL');

    if (!host) {
      host = sessionStorage.getItem('apiURL');
    }

    return host;
  }

  get user(): string {
    const local = sessionStorage.getItem('loggedUser');

    if (!local) {
      return '';
    }

    const lu = JSON.parse(local);
    return lu.data.id;
  }

  get options(): any {
    const token = sessionStorage.getItem('token');

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      Authorization: token
    });

    return {
      headers
    };
  }

}
